import { Button, TableLink } from "../components/Buttons";
import "./admin.css";
import {
  ActivateButton,
  ActivatingButton,
  ArchivingButton,
  InputText,
  InputTextArea,
  LinkComponent,
  MoreDropDown,
  Uploading,
} from "./AdminComponentsList";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import * as actionTypes from "../store/actions";
import * as adminActionTypes from "../store/actions/adminIndex";
import Spinner from "../components/Spinner";
import parse from "html-react-parser";
import AsyncSelect from "react-select/async";
import contants, {
  successUpdateNotification,
  successDeleteNotification,
  confirmNotification,
} from "./contants";
import {ReactNotifications} from "react-notifications-component";
import { MyDataTable } from "./MyDataTable";
import { AdminHeaderMenu, SideMenu } from "./Menus";
import { useParams } from "react-router";
import moment from "moment";
import {
  DisplayMedia,
  GenericDisplayMedia,
} from "./AdminGallerieComponentsList";

import dotenv from "dotenv";
dotenv.config();
const  ReactNotification=ReactNotifications


export const PreviewCarousel = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const object = useSelector((state) => state.adminHome.homeCarousel);
  const [video, setVideo] = useState(null);
  const objectLoading = useSelector(
    (state) => state.adminHome.adminHomeCarouselLoading
  );

  useEffect(() => {
    dispatch(adminActionTypes.getOneAdminHomeCarousels(params.objectId));
  }, [dispatch]);

  const activate = () => {
    if (window.confirm("Are you sure you want activate/desactivate?")) {
      if (object.status == contants.active) {
        dispatch(adminActionTypes.desactivateAdminHomeCarousels(object.uuid));
        successUpdateNotification("Home Carousel", contants.INACTIVE);
      } else {
        dispatch(adminActionTypes.activateAdminHomeCarousels(object.uuid));
        successUpdateNotification("Home Carousel", contants.ACTIVE);
      }
    } else {
    }
  };

  const archive = () => {
    if (window.confirm("Are you sure you want archive/set to visible?")) {
      if (object.access == contants.visible) {
        dispatch(adminActionTypes.archiveAdminHomeCarousels(object.uuid));
        successUpdateNotification("Home Carousel", contants.ARCHIVE);
      } else {
        dispatch(adminActionTypes.visibleAdminHomeCarousels(object.uuid));
        successUpdateNotification("Home Carousel", contants.VISIBLE);
      }
    } else {
    }
  };

  const onDelete = () => {
    if (window.confirm("Are you sure you want delete?")) {
      dispatch(adminActionTypes.deleteAdminHomeCarousels(object.uuid));
      successDeleteNotification("Home Carousel");
    } else {
    }
  };

  return (
    <div>
      <ReactNotification />
      <AdminHeaderMenu />
      <div className="flex">
        <div>
          <SideMenu />
        </div>
        {objectLoading && object ? (
          <div className="w-full h-80vh flex items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <form className="flex justify-between pt-6 px-12 w-full">
            <div className="flex flex-col pt-5 w-full">
              <div className="font-bold">
                <span className="admin-page-title text-xl">
                  CAROUSEL PREVIEW
                </span>
              </div>

              <div className="flex w-full space-x-10">
                <div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Header:</span>
                    <span className="site-text-blue px-3">
                      {object?.header}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Subtitle:</span>
                    <div className="site-text-blue px-3">
                      {object?.subtitle != undefined
                        ? parse(eval(object?.subtitle))
                        : parse("<p></p>")}
                    </div>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Language :</span>
                    <span className="site-text-blue px-3">
                      {object?.language}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Creator :</span>
                    <span className="site-text-blue px-3">
                      {object?.creator}
                    </span>{" "}
                  </div>
                </div>
                <div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Created At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.createdAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Updated At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.updatedAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Status :</span>
                    <span
                      className={
                        object?.status == contants.active
                          ? "bg-green-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-red-600 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.status}
                    </span>{" "}
                    <button
                      onClick={activate}
                      className={
                        object?.status == contants.active
                          ? "bg-red-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-green-600 px-4 text-white rounded-lg"
                      }
                    >
                      {object?.status == contants.active
                        ? "DESACTIVATE"
                        : "ACTIVATE"}{" "}
                    </button>
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Access :</span>
                    <span
                      className={
                        object?.access == contants.visible
                          ? "bg-blue-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-gray-500 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.access}
                    </span>{" "}
                    <button
                      onClick={archive}
                      className={
                        object?.access == contants.visible
                          ? "bg-gray-500 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-blue-600 px-4 text-white rounded-lg"
                      }
                    >
                      {object?.access == contants.visible
                        ? "ARCHIVE"
                        : "VISIBLE"}{" "}
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex justify-between h-80 ">
                <GenericDisplayMedia media={object?.coverimage} />
                <GenericDisplayMedia media={object?.video} />
              </div>
            </div>
            <div className="flex flex-col space-y-2">
              <TableLink
                title="Update"
                type="updateLink"
                link="/admin/home-carousel"
                objectId={object != null ? object.uuid : ""}
              />
              <Button name="DELETE" type="delete" onClick={onDelete} />
              <TableLink
                title="List"
                type="viewLink"
                link="/admin/home-carousel/objects/list"
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export const PreviewHomeAbout = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const object = useSelector((state) => state.adminHome.homeAbout);
  const objectLoading = useSelector(
    (state) => state.adminHome.adminHomeAboutlLoading
  );

  useEffect(() => {
    dispatch(adminActionTypes.getOneAdminHomeAbout(params.objectId));
  }, [dispatch]);

  const activate = () => {
    if (window.confirm("Are you sure you want activate/desactivate?")) {
      if (object.status == contants.active) {
        dispatch(adminActionTypes.desactivateAdminHomeAbouts(object.uuid));
        successUpdateNotification("Home About", contants.INACTIVE);
      } else {
        dispatch(adminActionTypes.activateAdminHomeAbouts(object.uuid));
        successUpdateNotification("Home About", contants.ACTIVE);
      }
    } else {
    }
  };

  const archive = () => {
    if (window.confirm("Are you sure you want archive/set to visible?")) {
      if (object.access == contants.visible) {
        dispatch(adminActionTypes.archiveAdminHomeAbouts(object.uuid));
        successUpdateNotification("Home About", contants.ARCHIVE);
      } else {
        dispatch(adminActionTypes.visibleAdminHomeAbouts(object.uuid));
        successUpdateNotification("Home About", contants.VISIBLE);
      }
    } else {
    }
  };

  const onDelete = () => {
    if (window.confirm("Are you sure you want delete?")) {
      dispatch(adminActionTypes.deleteAdminHomeAbouts(object.uuid));
      successDeleteNotification("Home About");
    } else {
    }
  };

  return (
    <div>
      <ReactNotification />
      <AdminHeaderMenu />
      <div className="flex">
        <div>
          <SideMenu />
        </div>
        {objectLoading && object ? (
          <div className="w-full h-80vh flex items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <form className="flex justify-between pt-6 px-12 w-full">
            <div className="flex flex-col pt-5 w-full">
              <div className="font-bold">
                <span className="admin-page-title text-xl">
                  HOME ABOUT PREVIEW
                </span>
              </div>

              <div className="flex w-full space-x-10">
                <div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Title :</span>
                    <span className="site-text-blue px-3">
                      {object?.title}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Subtitle :</span>
                    <span className="site-text-blue px-3">
                      {object?.subtitle}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Description:
                    </span>
                    <span className="site-text-blue px-3">
                      {object?.description != undefined
                        ? parse(eval(object?.description))
                        : parse("<p></p>")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Language :</span>
                    <span className="site-text-blue px-3">
                      {object?.language}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Creator :</span>
                    <span className="site-text-blue px-3">
                      {object?.creator}
                    </span>{" "}
                  </div>
                </div>
                <div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Created At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.createdAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Updated At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.updatedAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Status :</span>
                    <span
                      className={
                        object?.status == contants.active
                          ? "bg-green-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-red-600 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.status}
                    </span>{" "}
                    <button
                      onClick={activate}
                      className={
                        object?.status == contants.active
                          ? "bg-red-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-green-600 px-4 text-white rounded-lg"
                      }
                    >
                      {object?.status == contants.active
                        ? "DESACTIVATE"
                        : "ACTIVATE"}{" "}
                    </button>
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Access :</span>
                    <span
                      className={
                        object?.access == contants.visible
                          ? "bg-blue-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-gray-500 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.access}
                    </span>{" "}
                    <button
                      onClick={archive}
                      className={
                        object?.access == contants.visible
                          ? "bg-gray-500 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-blue-600 px-4 text-white rounded-lg"
                      }
                    >
                      {object?.access == contants.visible
                        ? "ARCHIVE"
                        : "VISIBLE"}{" "}
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex justify-between h-80 ">
                <GenericDisplayMedia media={object?.image} />
              </div>
            </div>
            <div className="flex flex-col space-y-2">
              <TableLink
                title="Update"
                type="updateLink"
                link="/admin/home-about"
                objectId={object != null ? object.uuid : ""}
              />
              <Button name="DELETE" type="delete" onClick={onDelete} />
              <TableLink
                title="List"
                type="viewLink"
                link="/admin/home-about/objects/list"
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export const PreviewHomeProduct = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const object = useSelector((state) => state.adminHome.homeProduct);
  const [video, setVideo] = useState(null);
  const objectLoading = useSelector(
    (state) => state.adminHome.adminProductsLoading
  );

  useEffect(() => {
    dispatch(adminActionTypes.getOneAdminHomeProducts(params.objectId));
  }, [dispatch]);

  const activate = () => {
    if (window.confirm("Are you sure you want activate/desactivate?")) {
      if (object.status == contants.active) {
        dispatch(adminActionTypes.desactivateAdminHomeProducts(object.uuid));
        successUpdateNotification("Home Product", contants.INACTIVE);
      } else {
        dispatch(adminActionTypes.activateAdminHomeProducts(object.uuid));
        successUpdateNotification("Home Product", contants.ACTIVE);
      }
    } else {
    }
  };

  const archive = () => {
    if (window.confirm("Are you sure you want archive/set to visible?")) {
      if (object.access == contants.visible) {
        dispatch(adminActionTypes.archiveAdminHomeProducts(object.uuid));
        successUpdateNotification("Home Product", contants.ARCHIVE);
      } else {
        dispatch(adminActionTypes.visibleAdminHomeProducts(object.uuid));
        successUpdateNotification("Home Product", contants.VISIBLE);
      }
    } else {
    }
  };

  const onDelete = () => {
    if (window.confirm("Are you sure you want delete?")) {
      dispatch(adminActionTypes.deleteAdminHomeProducts(object.uuid));
      successDeleteNotification("Home Product");
    } else {
    }
  };

  return (
    <div>
      <ReactNotification />
      <AdminHeaderMenu />
      <div className="flex">
        <div>
          <SideMenu />
        </div>
        {objectLoading && object ? (
          <div className="w-full h-80vh flex items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <form className="flex justify-between pt-6 px-12 w-full">
            <div className="flex flex-col pt-5 w-full">
              <div className="font-bold">
                <span className="admin-page-title text-xl">
                  HOME PRODUCT PREVIEW
                </span>
              </div>

              <div className="flex w-full space-x-10">
                <div className="w-3/5">
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Title :</span>
                    <span className="site-text-blue px-3">
                      {object?.title}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Info:</span>
                    <span className="site-text-blue px-3">
                      {object?.info != undefined
                        ? parse(eval(object?.info))
                        : parse("<p></p>")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Language :</span>
                    <span className="site-text-blue px-3">
                      {object?.language}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Creator :</span>
                    <span className="site-text-blue px-3">
                      {object?.creator}
                    </span>{" "}
                  </div>
                </div>
                <div className="w-2/5">
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Created At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.createdAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Updated At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.updatedAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Status :</span>
                    <span
                      className={
                        object?.status == contants.active
                          ? "bg-green-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-red-600 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.status}
                    </span>{" "}
                    <button
                      onClick={activate}
                      className={
                        object?.status == contants.active
                          ? "bg-red-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-green-600 px-4 text-white rounded-lg"
                      }
                    >
                      {object?.status == contants.active
                        ? "DESACTIVATE"
                        : "ACTIVATE"}{" "}
                    </button>
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Access :</span>
                    <span
                      className={
                        object?.access == contants.visible
                          ? "bg-blue-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-gray-500 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.access}
                    </span>{" "}
                    <button
                      onClick={archive}
                      className={
                        object?.access == contants.visible
                          ? "bg-gray-500 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-blue-600 px-4 text-white rounded-lg"
                      }
                    >
                      {object?.access == contants.visible
                        ? "ARCHIVE"
                        : "VISIBLE"}{" "}
                    </button>
                  </div>
                </div>
              </div>
              <div className="flex justify-between h-80 ">
                <GenericDisplayMedia media={object?.video} />
              </div>
            </div>
            <div className="flex flex-col space-y-2">
              <TableLink
                title="Update"
                type="updateLink"
                link="/admin/home-product"
                objectId={object != null ? object.uuid : ""}
              />
              <Button name="DELETE" type="delete" onClick={onDelete} />
              <TableLink
                title="List"
                type="viewLink"
                link="/admin/home-product/objects/list"
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export const PreviewHomeServiceIntro = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const object = useSelector((state) => state.adminHome.homeServiceIntro);
  const objectLoading = useSelector(
    (state) => state.adminHome.adminHomeServicesIntroLoading
  );

  useEffect(() => {
    dispatch(adminActionTypes.getOneAdminServicesIntro(params.objectId));
  }, [dispatch]);

  const activate = () => {
    if (window.confirm("Are you sure you want activate/desactivate?")) {
      if (object.status == contants.active) {
        dispatch(
          adminActionTypes.desactivateAdminHomeServicesIntros(object.uuid)
        );
        successUpdateNotification("Home Service Intro", contants.INACTIVE);
      } else {
        dispatch(adminActionTypes.activateAdminHomeServicesIntros(object.uuid));
        successUpdateNotification("Home Service Intro", contants.ACTIVE);
      }
    } else {
    }
  };

  const archive = () => {
    if (window.confirm("Are you sure you want archive/set to visible?")) {
      if (object.access == contants.visible) {
        dispatch(adminActionTypes.archiveAdminHomeServicesIntros(object.uuid));
        successUpdateNotification("Home Service Intro", contants.ARCHIVE);
      } else {
        dispatch(adminActionTypes.visibleAdminHomeServicesIntros(object.uuid));
        successUpdateNotification("Home Service Intro", contants.VISIBLE);
      }
    } else {
    }
  };

  const onDelete = () => {
    if (window.confirm("Are you sure you want delete?")) {
      dispatch(adminActionTypes.deleteAdminHomeServicesIntros(object.uuid));
      successDeleteNotification("Home ServiceIntro");
    } else {
    }
  };

  return (
    <div>
      <ReactNotification />
      <AdminHeaderMenu />
      <div className="flex">
        <div>
          <SideMenu />
        </div>
        {objectLoading && object ? (
          <div className="w-full h-80vh flex items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <form className="flex justify-between pt-6 px-12 w-full">
            <div className="flex flex-col pt-5 w-full">
              <div className="font-bold">
                <span className="admin-page-title text-xl">
                  HOME SERVICE INTRO PREVIEW
                </span>
              </div>

              <div className="flex w-full space-x-10">
                <div className="w-3/5">
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Title :</span>
                    <span className="site-text-blue px-3">
                      {object?.title}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Description:
                    </span>
                    <span className="site-text-blue px-3">
                      {object?.description != undefined
                        ? parse(eval(object?.description))
                        : parse("<p></p>")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Language :</span>
                    <span className="site-text-blue px-3">
                      {object?.language}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Creator :</span>
                    <span className="site-text-blue px-3">
                      {object?.creator}
                    </span>{" "}
                  </div>
                </div>
                <div className="w-2/5">
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Created At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.createdAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Updated At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.updatedAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Status :</span>
                    <span
                      className={
                        object?.status == contants.active
                          ? "bg-green-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-red-600 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.status}
                    </span>{" "}
                    <button
                      onClick={activate}
                      className={
                        object?.status == contants.active
                          ? "bg-red-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-green-600 px-4 text-white rounded-lg"
                      }
                    >
                      {object?.status == contants.active
                        ? "DESACTIVATE"
                        : "ACTIVATE"}{" "}
                    </button>
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Access :</span>
                    <span
                      className={
                        object?.access == contants.visible
                          ? "bg-blue-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-gray-500 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.access}
                    </span>{" "}
                    <button
                      onClick={archive}
                      className={
                        object?.access == contants.visible
                          ? "bg-gray-500 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-blue-600 px-4 text-white rounded-lg"
                      }
                    >
                      {object?.access == contants.visible
                        ? "ARCHIVE"
                        : "VISIBLE"}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col space-y-2">
              <TableLink
                title="Update"
                type="updateLink"
                link="/admin/home-service-intro"
                objectId={object != null ? object.uuid : ""}
              />
              <Button name="DELETE" type="delete" onClick={onDelete} />
              <TableLink
                title="List"
                type="viewLink"
                link="/admin/home-service-intro/objects/list"
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export const PreviewHomeTodayQuote = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const object = useSelector((state) => state.adminHome.homeTodaysQuote);
  const objectLoading = useSelector(
    (state) => state.adminHome.adminHomeTodaysQuoteLoading
  );

  useEffect(() => {
    dispatch(adminActionTypes.getOneAdminHomeTodayQuotes(params.objectId));
  }, [dispatch]);

  const activate = () => {
    if (window.confirm("Are you sure you want activate/desactivate?")) {
      if (object.status == contants.active) {
        dispatch(adminActionTypes.desactivateAdminHomeTodayQuotes(object.uuid));
        successUpdateNotification("Home TodayQuote", contants.INACTIVE);
      } else {
        dispatch(adminActionTypes.activateAdminHomeTodayQuotes(object.uuid));
        successUpdateNotification("Home TodayQuote", contants.ACTIVE);
      }
    } else {
    }
  };

  const archive = () => {
    if (window.confirm("Are you sure you want archive/set to visible?")) {
      if (object.access == contants.visible) {
        dispatch(adminActionTypes.archiveAdminHomeTodayQuotes(object.uuid));
        successUpdateNotification("Home TodayQuote", contants.ARCHIVE);
      } else {
        dispatch(adminActionTypes.visibleAdminHomeTodayQuotes(object.uuid));
        successUpdateNotification("Home TodayQuote", contants.VISIBLE);
      }
    } else {
    }
  };

  const onDelete = () => {
    if (window.confirm("Are you sure you want delete?")) {
      dispatch(adminActionTypes.deleteAdminHomeTodayQuotes(object.uuid));
      successDeleteNotification("Home TodayQuote");
    } else {
    }
  };

  return (
    <div>
      <ReactNotification />
      <AdminHeaderMenu />
      <div className="flex">
        <div>
          <SideMenu />
        </div>
        {objectLoading && object ? (
          <div className="w-full h-80vh flex items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <form className="flex justify-between pt-6 px-12 w-full">
            <div className="flex flex-col pt-5 w-full">
              <div className="font-bold pb-5">
                <span className="admin-page-title text-xl">
                  TODAYS QUOTES PREVIEW
                </span>
              </div>

              <div className="flex w-full space-x-10">
                <div className="w-3/5">
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Owner :</span>
                    <span className="site-text-blue px-3">
                      {object?.owner}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Quote:</span>
                    <span className="site-text-blue px-3">
                      {object?.quote != undefined
                        ? parse(eval(object?.quote))
                        : parse("<p></p>")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Language :</span>
                    <span className="site-text-blue px-3">
                      {object?.language}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Creator :</span>
                    <span className="site-text-blue px-3">
                      {object?.creator}
                    </span>{" "}
                  </div>
                </div>
                <div className="w-2/5">
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Created At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.createdAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">
                      Updated At :
                    </span>
                    <span className="site-text-blue px-3">
                      {moment(object?.updatedAt).format("DD-MM-YYYY")}
                    </span>{" "}
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Status :</span>
                    <span
                      className={
                        object?.status == contants.active
                          ? "bg-green-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-red-600 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.status}
                    </span>{" "}
                    <ActivatingButton
                      onClick={activate}
                      status={object?.status}
                    />
                  </div>
                  <div className="flex py-2">
                    <span className="site-text-blue font-bold">Access :</span>
                    <span
                      className={
                        object?.access == contants.visible
                          ? "bg-blue-600 px-4 text-white text-md rounded-sm ml-4"
                          : "bg-gray-500 px-4 text-white rounded-sm"
                      }
                    >
                      {object?.access}
                    </span>{" "}
                    <ArchivingButton
                      onClick={archive}
                      access={object?.access}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col space-y-2">
              <TableLink
                title="Update"
                type="updateLink"
                link="/admin/home-quote"
                objectId={object != null ? object.uuid : ""}
              />
              <Button name="DELETE" type="delete" onClick={onDelete} />
              <TableLink
                title="List"
                type="viewLink"
                link="/admin/home-quote/objects/list"
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
